import { render, staticRenderFns } from "./mindsets-panel.vue?vue&type=template&id=1c5c45c3&scoped=true"
import script from "./mindsets-panel.ts?vue&type=script&lang=ts&external"
export * from "./mindsets-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./mindsets-panel.scss?vue&type=style&index=0&id=1c5c45c3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c45c3",
  null
  
)

export default component.exports